export default "__VITE_ASSET__BGxq$A9f__"